import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_a7e7976c from 'nuxt_plugin_plugin_a7e7976c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_0c82f838 from 'nuxt_plugin_plugin_0c82f838' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_plugin_10f2649c from 'nuxt_plugin_plugin_10f2649c' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_nuxtleaflet_3455a665 from 'nuxt_plugin_nuxtleaflet_3455a665' // Source: ./nuxt-leaflet.js (mode: 'client')
import nuxt_plugin_workbox_03fd5b7c from 'nuxt_plugin_workbox_03fd5b7c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_c61d32e2 from 'nuxt_plugin_metaplugin_c61d32e2' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_bccde7fa from 'nuxt_plugin_iconplugin_bccde7fa' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_72f2fe60 from 'nuxt_plugin_axios_72f2fe60' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_mapirvueclient_a25d6db0 from 'nuxt_plugin_mapirvueclient_a25d6db0' // Source: ../plugins/mapir-vue.client.js (mode: 'client')
import nuxt_plugin_vuelidate_45aab49a from 'nuxt_plugin_vuelidate_45aab49a' // Source: ../plugins/vuelidate.js (mode: 'all')
import nuxt_plugin_laravelecho_42058a2a from 'nuxt_plugin_laravelecho_42058a2a' // Source: ../plugins/laravel-echo.js (mode: 'client')
import nuxt_plugin_vueawesomeswiper_4af85e3f from 'nuxt_plugin_vueawesomeswiper_4af85e3f' // Source: ../plugins/vue-awesome-swiper (mode: 'client')
import nuxt_plugin_datepicker_f86071f6 from 'nuxt_plugin_datepicker_f86071f6' // Source: ../plugins/datepicker.js (mode: 'client')
import nuxt_plugin_jalalimoment_775f0609 from 'nuxt_plugin_jalalimoment_775f0609' // Source: ../plugins/jalali-moment.js (mode: 'client')
import nuxt_plugin_scrollable_5bbbeb3a from 'nuxt_plugin_scrollable_5bbbeb3a' // Source: ../plugins/scrollable.js (mode: 'client')
import nuxt_plugin_auth_33314260 from 'nuxt_plugin_auth_33314260' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_meta_686b2578 from 'nuxt_plugin_meta_686b2578' // Source: ./composition-api/meta.mjs (mode: 'all')
import nuxt_plugin_echo_cab9b59a from 'nuxt_plugin_echo_cab9b59a' // Source: ./echo.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"HiTaxi","title":"HiTaxi","htmlAttrs":{"lang":"fa"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"default"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","href":"\u002Ficon2.png","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-2048-2732.jpg","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-2732-2048.jpg","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-1668-2388.jpg","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-2388-1668.jpg","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-1536-2048.jpg","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-2048-1536.jpg","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-1668-2224.jpg","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-2224-1668.jpg","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-1620-2160.jpg","media":"(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-2160-1620.jpg","media":"(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-1284-2778.jpg","media":"(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-2778-1284.jpg","media":"(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-1170-2532.jpg","media":"(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-2532-1170.jpg","media":"(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-1125-2436.jpg","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-2436-1125.jpg","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-1242-2688.jpg","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-2688-1242.jpg","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-828-1792.jpg","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-1792-828.jpg","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-1242-2208.jpg","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-2208-1242.jpg","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-750-1334.jpg","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-1334-750.jpg","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-640-1136.jpg","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)","ssr":false},{"rel":"apple-touch-startup-image","href":"splashscreens\u002Fapple-splash-1136-640.jpg","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)","ssr":false},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"script":[],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_a7e7976c === 'function') {
    await nuxt_plugin_plugin_a7e7976c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0c82f838 === 'function') {
    await nuxt_plugin_plugin_0c82f838(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_10f2649c === 'function') {
    await nuxt_plugin_plugin_10f2649c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtleaflet_3455a665 === 'function') {
    await nuxt_plugin_nuxtleaflet_3455a665(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_03fd5b7c === 'function') {
    await nuxt_plugin_workbox_03fd5b7c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_c61d32e2 === 'function') {
    await nuxt_plugin_metaplugin_c61d32e2(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_bccde7fa === 'function') {
    await nuxt_plugin_iconplugin_bccde7fa(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_72f2fe60 === 'function') {
    await nuxt_plugin_axios_72f2fe60(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mapirvueclient_a25d6db0 === 'function') {
    await nuxt_plugin_mapirvueclient_a25d6db0(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_45aab49a === 'function') {
    await nuxt_plugin_vuelidate_45aab49a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_laravelecho_42058a2a === 'function') {
    await nuxt_plugin_laravelecho_42058a2a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_4af85e3f === 'function') {
    await nuxt_plugin_vueawesomeswiper_4af85e3f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datepicker_f86071f6 === 'function') {
    await nuxt_plugin_datepicker_f86071f6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_jalalimoment_775f0609 === 'function') {
    await nuxt_plugin_jalalimoment_775f0609(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrollable_5bbbeb3a === 'function') {
    await nuxt_plugin_scrollable_5bbbeb3a(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_33314260 === 'function') {
    await nuxt_plugin_auth_33314260(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_686b2578 === 'function') {
    await nuxt_plugin_meta_686b2578(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_echo_cab9b59a === 'function') {
    await nuxt_plugin_echo_cab9b59a(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
